{
  "version": 1,
  "asset_id": "29f9c91e-c157-41ae-a760-b7e58c16f37a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/29f9c91e-c157-41ae-a760-b7e58c16f37a/ind-real-estate-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/29f9c91e-c157-41ae-a760-b7e58c16f37a/ind-real-estate-1200.avif",
  "original_filename": "ind-real-estate-1200.avif",
  "size": 12122,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:10Z"
}
